import { InventorySwingCard } from "@/components/domain/InventorySwingCard";

/**
 * Inventory Swing — dedicated page. Wraps the same card used on the
 * Overview but at full width so the per-asset state table and recent
 * cycle log have room to breathe.
 */
export default function InventorySwing() {
  return (
    <div className="space-y-4">
      <InventorySwingCard />
    </div>
  );
}
